module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter2"
    }
  }), _c('strong', [_vm._v("A Note about Transcription of the Documents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("American and Soviet intelligence agencies had the practice in written documents and messages of printing proper names, including cover names, completely in capital letters. This was done to signal that when one read “on Monday PILOT reported,” the source of the report was not a real pilot. Persons not used to reading intelligence material, however, frequently mistake the purpose of such capitalization for emphasis. To avoid distraction, the practice will not be followed in this book; only the initial letter of a cover name will be capitalized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The documents decrypted in the Venona Project were translated from Russian over the period 1946-1981. During that time National Security Agency practices on transliterating Russian words and names from the Cyrillic to the Latin alphabet changed several times. Furthermore, a portion of work was done by British linguists, who rendered the translations in British English rather than American English. To avoid distracting readers who will wonder, understandably, if the “Anatolii” of one document is the same person as the “Anatoly” of another, all such words will be rendered under a single standard of anglicization.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every deciphered cable of the Venona Project is given a unique citation that identifies the message by the sending and receiving station, the date of transmission, the agency of transmission, and an “external” message number given to the cable by the National Security Agency. "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("(The NSA derived the external number from a sequential number actually placed in the outgoing cable by Soviet code clerks.) A citation of “Venona 722 KGB New York to Moscow, 21 May 1942” refers to a ciphered cable message sent by the KGB station in New York to the KGB headquarters in Moscow on May 21, 1942, and given the external number 722 by the Venona Project. Complete sets of the Venona messages are available at the Manuscript Division of the Library of Congress, at the NSA’s National Cryptologie Museum, Fort Meade, Maryland, and, as of 1998, on the NSA’s World Wide Web page ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nsa.gov",
      "target": "_blank"
    }
  }, [_vm._v("www.nsa.gov")]), _vm._v(").")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c3f426","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter2.vue
// module id = 75
// module chunks = 0